import { post, get } from '@/utils/network';

export interface CourseItem {
  id: string; // 课程id
  issys: '0' | '1'; //是否为系统创建 0:否 1:是
  coursename: string; // 课程名字
  code: string; // 加课码
  stopcode: 0 | 1; // 是否停用加课码
  classname: string; //班级名
  semester: string; // 学期
  term: number; // 学期分类
  identity: string; // 老师身份
  icontype: number; // 角色
  isrecruit: '0' | '1'; // 是否双选会0no 1 yes
  isTop: 0 | 1; // 是否置顶0no 1 yes
  username: string; // 用户名
  avatar: string; // 头像url地址
  minpic: string; // 最小图
  middlepic: string; // 中图
  bannercolor: string; // banner 的颜色 #xxxxxx 格式
  studentbgpic: string; // 学生封面大图
  studentminpic: string; // 学生封面小兔
  teacherbgpic: string; // 老师封面大图
  teacherminpic: string; // 老师封面小兔
  living: 0 | 1; // 是否正在直播
  liveState: 0 | 1;
  total: number; // 作业数量
  hlist: Array<{
    // 作业列表
    id: string; //作业id
    title: string; // 作业标题
    type: 0 | 1; // 作业类型 0 个人作业 1 小组作业
  }>;
  role: 0 | 1; // 0学生 1老师
  bgcolor: string;
  // "inviteclass":string,
  // "tclass":string,
  students: Array<{
    // 学生列表
    username: string; // 学生名
    uid: string; // 学生id
    avatar: string; // 学生头像
  }>;
  withScreenState: 0 | 1; // 是否有同屏互动 0:否 1:是
  isattest: boolean; // 是否已认证
  have_class: 0 | 1; // 是否正在上课
}
export interface semesterItem {
  semester?: string | null;
  term?: string | null;
  termTxt?: string | null;
  unfold?:boolean;
  list?:any[];
}

export interface CourseItemForActions {
  courseid?: string | null;
  coursename: string;
  venue: string;
  canview: 0 | 1;
  classname?: string;
  semester?: string;
  term?: string;
  relation?: string;
  teachClassid?: string;
  neednatureclass?: 0 | 1;
  needgrade?: 0 | 1;
  needentrance?: 0 | 1;
  setting?: {
    classno?: 0 | 1; // === neednatureclass
    grade?: 0 | 1; // === needgrade
    enrolltime?: 0 | 1; // === needentrance
  };
  teachtype?: number;
  studytime?: number | string;
  describes?: string
}

export const getCourseList = () => {
  return post<{
    toplists: Array<CourseItem>;
    lists: Array<CourseItem>;
    sysCount: number; // 课程总数
    number: number; // 已创建课程数
  }>('/courseApi/lists');
};
export const getSimpleCourseList = () => {
  return post<{
    toplists: Array<CourseItem>;
    lists: Array<CourseItem>;
    sysCount: number; // 课程总数
    number: number; // 已创建课程数
  }>('/courseApi/simpleLists');
};
//课程学期-列表（置顶课程+课程所属学期）
export const getSemesterList = (param: {isstudy:string;search:string}) => {
  return post<{
    topcourses: Array<CourseItem>;
    semester:Array<semesterItem>
  }>('/courseApi/semesterList',param);
};
//课程详情-列表（某学期下的）
export const getSemesterCourseList = (param: {isstudy:string;search:string;semester:string;term:string;}) => {
  return post('/CourseApi/semesterCourseList', param);
};

// 课程排序
export const updateCourseSortBat = (param: {courseidlist:string;}) => {
  return post('/CourseApi/updateCourseSortBat', param);
};
export const createCourse = (param: CourseItemForActions) => {
  return post('/CourseApi/createCourse', param);
};

// 更新课程报名设置
export function updateEnrollSetting(params: {
  courseid: string,
  enrollstate: string,
  auditstate: string,
  joinlabelid: string,
  formLists: {
    title: string,
    selected: string
  }[]
}) {
  return post('/Futurev2/CourseEnroll/updateSetting', params)
}

// 获取某个课程的是否报名的状态，如果需要报名，则会返回学生的报名状态
export function getEnrollState(params: { courseid?: string, code?: string }) {
  return post<{
    enrollState: string,
    joinlabelid: string,
    // 【0：待审核  1：审核通过  2：已拒绝】   -1表示未报名
    auditState?: number
    courseRole: number,
  }>('/Futurev2/CourseEnroll/getEnrollState', params)
}
export interface courseEnrollInfo {
  id: string
  coursename: string
  classname: string
  stopcode: string
  uid: string
  describes: string
  joinMember: string
  minpic: string
  share: number,
  teacherInfo: {
    username: string
    school: string
    avatar: string
  },
  enroll: {
    enrollState: string
    joinlabelid: string
    // 【0：待审核  1：审核通过  2：已拒绝】   -1表示未报名
    auditState?: number | string,
    courseRole: number,
  }
}
// 获取某个课程的是否报名的状态，如果需要报名，则会返回学生的报名状态
export function getCourseInfo(params: { courseid?: string, code: string }) {
  return post<courseEnrollInfo>('/Futurev2/CourseEnroll/getCourseInfo', params)
}
export interface enrollFormItem {
  id:string,
  title: string,
  itemval: string,
}

/**
 * 获取需要填写的表单（学员加课时）
 * @param params
 * @return enrollFormItem
 */
export function getEnrollFormList(params: { courseid: string }) {
  return post<{ formLists: enrollFormItem[] }>('/Futurev2/CourseEnroll/getEnrollFormList', params)
}

export function submitEnrollForm(params: { courseid: string, formLists: { id: string, val: string }[] }) {
  return post('/Futurev2/CourseEnroll/enroll', params,false)
}

export interface AuditItem {
  id: string,
  uid: string,
  state: string,
  createtime: string,
  username: string,
  stno: string,
  avatar: string,
  account: string
}
// 获取报名的审核列表
export function getAuditLists(params: { courseid: string, state: string, page: number, pageSize: number }) {
  return post<{
    content: AuditItem[],
    stat: {
      passAuditCount: number,
      rejectAuditCount: number,
      waitAuditCount: number,
    },
    total: number
  }>('/Futurev2/CourseEnroll/getAuditLists', params)
}

export interface StudentEnrollForm {
  userInfo: {
    username: string,
    stno: string,
    avatar: string
  },
  enrolltime: string,
  formLists: enrollFormItem[]
}
// 获取某个学生的报名表单的填写情况
export function getStudentEnrollForm(params: { courseid: string, uid: string }) {
  return post<{ enroll: StudentEnrollForm }>('/Futurev2/CourseEnroll/getStudentEnrollForm', params)
}
// 变更审核状态
export function updateAuditState(params: { courseid: string, uids: string, state: string, joinlabelid:string}) {
  return post('/Futurev2/CourseEnroll/updateAuditState', params)
}
// 获取待审核的人数
export function getWaitAuditCount(params: { courseid: string }) {
  return post('/Futurev2/CourseEnroll/getWaitAuditCount', params)
}



export const renameCourse = (param: CourseItemForActions) => {
  return post('CourseApi/renameCourse', param);
};

export const getCourse = (courseid: string) => {
  return post<CourseItemForActions>('CourseApi/getCourse', { courseid });
};

export const joinCourseByCode = (code: string) => {
  return post<{
    coursename: string;
    courseid: string;
    teacher: {
      avatar: string;
      username: string;
    };
    join: 100 | 101; // 100-> success, 101 filed
    message: string;
  }>('/CourseApi/joinCourseByCode', { code }, false);
};
//返回当前学习的课程（直播-录屏-上课）中
export const getCourseStateAll = () => {
  return post('/CourseApi/getCourseStateAll',);
}
// 删除课程
export const deleteCourse = (param: { courseid: string; password: string }) => {
  return post('/CourseApi/delCourse', param);
};
//退出课程
export const quitCourse = (param: { courseid: string; password: string }) => {
  return post('/CourseApi/quitCourse', param);
};
export const getDeletePattern = (param: { courseid: string }) => {
  return post('/CourseApi/getDeletePattern', param);
};
// 添加归档
export const addArchive = (param: { courseid: string; type: '0' | '1', icontype: number }) => {
  return post('/ArchiveApi/addArchive', param);
};
export const changeRole = (param: object) => {
  return post('/UserApi/changeRole', param);
};
export const getCollegeList = (param: object) => {
  return post('/InformationSupplementApi/getCollegeList', param);
};
export const getMajorLists = (param: object) => {
  return post('/InformationSupplementApi/getMajorLists', param);
};
export const copyCourse = (param: any) => {
  return post('CourseApi/copyCourse', param);
};

export const transferCourse = (param: { account: string; password: string; courseid: string }) => {
  return post('CourseApi/transferCourse', param);
};

// 课程置顶
export const setCourseTop = (params: { courseid: string, icontype: number }) => {
  return post('/CourseApi/setCourseTop', params);
};
// 课程取消置顶
export const cancelCourseTop = (params: { courseid: string, icontype: number }) => {
  return post('/CourseApi/cancelCourseTop', params);
};

export const courseCodeStop = (courseid: string) => {
  console.log(courseid);
  return post('/CourseApi/stopCourseCode', { courseid });
};

export const courseCodeStart = (courseid: string) => {
  return post('/CourseApi/startCourseCode', { courseid });
};

export const courseCodeReset = (courseid: string) => {
  return post('/CourseApi/resetCourseCode', { courseid });
};
export interface FiledCourseSingle {
  archive_id: string;
  code: string;
  courseid: string;
  coursename: string;
  hlist: Array<any>;
  middlepic: string;
  minarpic: string;
  minpic: string;
  icontype: 0 | 1 | 2;
  role: 1 | 0;
  students: Array<any>;
  total: number;
  username: string;
}
export const getFiledCourseList = () => {
  return post<{
    lists: Array<FiledCourseSingle>;
  }>('/ArchiveApi/lists');
};
export const cancelFiledCourse = (params: { courseid: string, icontype: number }) => {
  return post('/ArchiveApi/cancleArchive', params);
};
// 是否需要完善用户信息
export const checkAuth = (courseId: string) => {
  return post<{
    state: 1 | 0; // 0需要填写，1不需要填写
    userInfo: {
      classno: string; // 班级
      enrolltime: string; // 入学时间
      grade: string; // 年级
      major: string;
    };
  }>('/CourseApi/checkMyInfo', {
    courseid: courseId
  });
};

// 更新自己在某个课程里面的要求填写的信息
export const updateMyCourseInfo = ({ courseid, data }: { courseid: string; data: any }) => {
  return post<any>('/StudentAddtionInfoApi/updateMyCourseInfo', {
    courseid,
    data
  });
};
// 获取课程信息
export const getCourseDetail = (params: any) => {
  return post('CourseBigDataApi/getCourseDetail', params)
}
// 更新课程信息
export const upCourseDetail = (params: any) => {
  return post('CourseBigDataApi/upCourseDetail', params)
}
// 更新课程高级设置
export const upIndependent = (params: any) => {
  return post('CourseBigDataApi/upIndependent', params)
}
// 记录访问课程（10分钟内只记录一次）
export const visitCourse = (params: { courseid: string }) => {
  return post('/courseApi/visitCourse', params)
}

export default {
  getCourseList,
  createCourse,
  deleteCourse,
  quitCourse,
  addArchive,
  copyCourse,
  transferCourse,
  courseCodeReset,
  courseCodeStart,
  courseCodeStop,
  getFiledCourseList,
  cancelFiledCourse,
  updateMyCourseInfo
};
